// Global Variable

// GWP Processing Flags - Prevent double execution
var isGiftProcessing = false;
var isMasterPromoRunning = false;

$(function () {
    initDate();
    initSlider();
    onloadRemoveSampleProduct();
    masterPromo(false);
    if (location.href.includes('/cart')) {
      var $loader = $('.jsc-loader-overlay');
      // Use namespaced event to prevent duplicate handlers
      $(document).off('cart.requestComplete.mainCart').on('cart.requestComplete.mainCart', function (event, cart) {
          $loader.hide();
          location.reload();
      });
    }
    getTaxAttr();
    removeOneCardError();
    initMySwiper();
    addCTSComplete();
    openCartDrawer();
    $('.custom-modal').click(function(event) {
      if (!$(event.target).closest('.modal-content').length) {
          $(this).fadeOut();
          $('body').removeClass('no-scroll');
      }
    });
});

// START Scroll to top button
var scrollToTopBtn = document.getElementById("scrollToTopBtn");
var rootElement = document.documentElement;

function scrollToTop() {
  // Scroll to top logic
  rootElement.scrollTo({
    top: 0,
    behavior: "smooth"
  });
}
scrollToTopBtn.addEventListener("click", scrollToTop);

// END Scroll to top button

// Start PDPA Function

customerAPI = (fn,ln,id,tel,birth,oTel,oBirth,prov,gen,oPro,oGen,oPdpa,nPdpa,pdpaId,pdpaIdList) =>{

  let $data = {
      id: id,
      first_name: fn,
      last_name: ln,
      telephone: `__tel:${tel}`,
      birthday: `__birthday:${birth}`,
      province: `__province:${prov}`,
      gender: `__gender:${gen}`,
      old_tel: oTel,
      old_brith: oBirth,
      old_pro: oPro,
      old_gen: oGen,
      old_pdpa: oPdpa,
      pdpa: nPdpa,
      pdpaId: `__id:${pdpaId}`,
      pdpaList: pdpaIdList
  };

  $.ajax({
    url: 'https://webhooks.mechanic.dev/f2b37171-65a6-4931-9c2d-b33913d6cb96',//user/custom/customer
    method: 'POST',
    headers: {
       'content-type': 'application/json'
    },
    data: JSON.stringify($data)
  });
}

customerInitAPI = (fn,ln,id,tel,birth,prov,gen,pdpa, pdpaId,email) =>{

  let $data = {
      id: id,
      first_name: fn,
      last_name: ln,
      telephone: `__tel:${tel}`,
      birthday: `__birthday:${birth}`,
      province: `__province:${prov}`,
      gender: `__gender:${gen}`,
      pdpa: `__pdpa:${pdpa}`,
      pdpaId: `__id:${pdpaId}`,
      email: email
  };

  $.ajax({
    url: 'https://webhooks.mechanic.dev/b9417eb8-6a1f-417f-8d51-a7b02ecaaf21', //user/custom/update
    method: 'POST',
    headers: {
       'content-type': 'application/json'
    },
    data: JSON.stringify($data)
  });
}

validateUpdate = ($first_name, $last_name, $telephone, $birthday) =>{
  var $isError = true;

  if ($first_name == '') {
      $('#first_name_error').show();
      $isError = false;
  } else {
      $('#first_name_error').hide();
  }
  if ($last_name == '') {
      $('#last_name_error').show();
      $isError = false;
  } else {
      $('#last_name_error').hide();
  }
  if ($telephone == '') {
      $('#telephone_error').show();
      $isError = false;
  } else {
      if ($telephone.length == 10) {
      $isError = true;
      $('#telephone_valid').hide();
      } else {
      $isError = false;
      $('#telephone_valid').show();
      }
      $('#telephone_error').hide();
  }
  if ($birthday == '') {
      $('#birthday_error').show();
      $isError = false;
  } else {
      $('#birthday_error').hide();
  }

  return $isError;
}

updatePdpa = (evt) =>{
  var $loader = $('.jsc-loader-overlay');
  $loader.show();
  var $this = $(evt);
  var $id = parseInt($('#jsc-customer-pdpa-id').val());
  var $idList = $('#jsc-customer-pdpa-id-list').val();
  var $shopifyId = parseInt($('#jsc-customer-id').val());
  var $first_name = $('#FirstName').val();
  var $last_name = $('#LastName').val();
  var $email = $('#Email').val();
  var $telephone = $('#jsc-register_mobile').val();
  var $birthday = $('#jsc-birthday').val();
  var $province = $('#jsc-province').val();
  var $gender = $('#jsc-gender').val();
  var $isvalidated = validateUpdate($first_name, $last_name, $telephone, $birthday);

  var $oldTel = $('#jsc-customter-old-tel').val();
  var $oldBirth = $('#jsc-customter-old-birth').val();
  var $oldProvince = $('#jsc-customter-old-province').val();
  var $oldGender = $('#jsc-customter-old-gender').val();
  var $isConsent = $('#jsc-accepts_marketing').prop('checked');
  var $oldPdpa = $isConsent ? '__pdpa:false' : '__pdpa:true';
  var $newPdpa = $isConsent ? '__pdpa:true' : '__pdpa:false';

  if($gender == 'Male'){
      $gender = 'ชาย';
  } else if($gender == 'Female'){
      $gender = 'หญิง';
  } else if($gender == 'Others'){
      $gender = 'อื่นๆ';
  }

  var $isId = isNaN($id);

  if ($isvalidated) {
    if ($isConsent || $isId) {
      var webhook = 'https://webhooks.mechanic.dev/f881b0fe-4981-42b0-b101-93ad32feae35'; // user/update_pdpa/one
      if ($gender != 'ชาย' && $gender != 'หญิง' && $gender != 'อื่นๆ') {
        $gender = '';
      }
  
      let $data = {
        first_name: $first_name,
        last_name: $last_name,
        birthday: $birthday,
        email: $email,
        telephone: $telephone,
        province: $province,
        gender: $gender,
        isConsent: $isConsent,
        shopify_customer_id: $shopifyId,
        old_tel: $oldTel,
        old_brith: $oldBirth,
        old_pro: $oldProvince,
        old_gen: $oldGender,
        old_pdpa: $oldPdpa,
        pdpa: $newPdpa,
        id_list: $idList
      };
      $.ajax({
        url: webhook,
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        data: JSON.stringify($data)
      }).done(function () {
        setTimeout(function(){
          $loader.hide();
          location.reload();
        },24000);
      });
    } else {
      var webhook_2 = 'https://webhooks.mechanic.dev/d1ae5feb-6dcc-477f-9456-fb7472269161'; // user/update_pdpa/two
      if ($gender != 'ชาย' && $gender != 'หญิง' && $gender != 'อื่นๆ') {
        $gender = '';
      }
  
      let $data = {
        id: $id,
        first_name: $first_name,
        last_name: $last_name,
        birthday: $birthday,
        email: $email,
        telephone: $telephone,
        province: $province,
        gender: $gender,
        isConsent: $isConsent,
        shopify_customer_id: $shopifyId,
        old_tel: $oldTel,
        old_brith: $oldBirth,
        old_pro: $oldProvince,
        old_gen: $oldGender,
        old_pdpa: $oldPdpa,
        pdpa: $newPdpa,
        id_list: $idList
      };
      $.ajax({
        url: webhook_2,
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        data: JSON.stringify($data)
      }).done(function () {
        setTimeout(function(){
          $loader.hide();
          location.reload();
        },24000);
      });
    }
  } else {
    $loader.hide();
  }
}

validateRegister = ($first_name, $last_name, $email, $telephone, $birthday, $password) =>{
  var $isError = true;

  if ($first_name == '') {
      $('#first_name_error').show();
      $isError = false;
  } else {
      $('#first_name_error').hide();
  }
  if ($last_name == '') {
      $('#last_name_error').show();
      $isError = false;
  } else {
      $('#last_name_error').hide();
  }
  if ($email == '') {
      $('#email_error').show();
      $isError = false;
  } else {
      $('#email_error').hide();
  }
  if ($telephone == '') {
      $('#telephone_error').show();
      $isError = false;
  } else {
      $('#telephone_error').hide();
      if ($telephone.length != 10) {
      $('#telephone_valid').show();
      $isError = false;
      } else {
      if ($telephone.slice(0,1) != '0') {
          $('#telephone_valid').show();
          $isError = false;
      }else {
          $('#telephone_valid').hide();
      }
      }
  }
  if ($birthday == '') {
      $('#birthday_error').show();
      $isError = false;
  } else {
      $('#birthday_error').hide();
  }
  if ($password == '') {
      $('#password_error').show();
      $isError = false;
  } else {
      $('#password_error').hide();
  }

  return $isError;
}

pdpaConsent = (evt) =>{
  var $loader = $('.jsc-loader-overlay');
  $loader.show();
  var $this = $(evt);
  var $form = $('#create_customer');
  var $first_name = $form.find('input[name="customer[first_name]"]').val();
  var $last_name = $form.find('input[name="customer[last_name]"]').val();
  var $email = $form.find('input[name="customer[email]"]').val();
  var $telephone = $form.find('input[name="telephone"]').val();
  var $birthday = $form.find('input[name="birthday"]').val();
  var $isConsent = $form.find('#jsc-accepts_marketing').prop('checked');
  var $password = $form.find('input[name="customer[password]"]').val();
  var $isvalidated = validateRegister($first_name, $last_name, $email, $telephone, $birthday, $password);


  setTimeout(function(){
      if ($isvalidated) {
          $('#jsc-customer-tag').val('__tel:'+$telephone+',__birthday:'+$birthday+',__pdpa:'+$isConsent);
          $this.siblings('.jsc-register-submit').click();
      }
      $loader.hide();
  },1800);
}

initDate = () =>{
  var startDate = new Date(1900, 1 - 1, 1);
  var currentDate = new Date();
  var endDate = new Date(new Date().getFullYear() - 10, currentDate.getMonth(), currentDate.getDate());
  $('#jsc-birthday').datepicker({
      format: 'yyyy-mm-dd',
      startDate: startDate,
      endDate: endDate,
      startView: 2,
      maxViewMode: 2
  });
}
// End PDPA Function


 //Cookies settings
 $(document).ready(function() {
  onLoadCookieBar();
});
 setCookies = (cname,cval,days) =>{
    const d = new Date();
    d.setTime(d.getTime() + (days*24*60*60*1000));
  
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cval + ";" + expires + ";path=/";
  }
  
  getCookies = (cname) =>{
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  
  acceptCookies = (e) =>{
    var $this = $(e);
  
    $this.parents('.jsc-cookies-container').hide();
  
    setCookies('jsc-accept-cookie', true, 120);
  }
  
  onLoadCookieBar = () =>{
    var isAccpet = getCookies('jsc-accept-cookie') === 'true';
    if (isAccpet) {
      $('.jsc-cookies-container').hide();
    }
    else {
      $('.jsc-cookies-container').removeClass('d-none');
    }
    console.log('Cookies accepted');
  }
  // Cookies settings end

initSlider = () => {
    $('.jsc-sample-product-slider').flickity({
        // options
        cellAlign: 'left',
        contain: true,
        freeScroll: true,
        pageDots: false
      });
}

cartJSAddQuery = (vid, qty, obj, isOpenDrawer) => {
// Cart js add item, success callback, error callback

    CartJS.addItem(vid, qty, obj,
    {
        // Define a success callback to display a success message.
        "success": function(data, textStatus, jqXHR) {
            fetch('/cart')
            .then((response) => response.text())
            .then((response) => {
                console.log('success');               
            })
            .catch((e) => {
                console.error(e);
                location.reload();
            });    
        },
        // Define an error callback to display an error message.
        "error": function(jqXHR, textStatus, errorThrown) {
            console.log("Error occur !", errorThrown);
        }
    });
}

cartJSUpdateQuery = (vid, qty, obj, isOpenDrawer) => {
    // Cart js add item, success callback, error callback
    
    CartJS.updateItemById(vid, qty, obj,
    {
        // Define a success callback to display a success message.
        "success": function(data, textStatus, jqXHR) {
            fetch('/cart')
            .then((response) => response.text())
            .then((response) => {
                console.log('success');      
            })
            .catch((e) => {
                console.error(e);
                location.reload();
            });
        },
        // Define an error callback to display an error message.
        "error": function(jqXHR, textStatus, errorThrown) {
            console.log("Error occur !", errorThrown,jqXHR,textStatus);
        }
    });
}
    
// Sample collection start
addSampleProduct = (e, vid) => {
    var $this = $(e);
    var $obj = {};
    var $loader = $('.jsc-loader-overlay');
    $loader.show();

    $obj['_Item'] = 'Sample item';
    // $obj['_Promo'] = 'Free Gift';
    cartJSAddQuery(vid, 1, $obj, false);
    
    if (location.href.includes('/cart')) {
    }else{
    $(document).on('cart.requestComplete', function (event, cart) {
        location.reload();
        $loader.hide();
    });
    }
  }
  
  removeSampleProduct = (e, key) => {
    var $this = $(e);
    var $loader = $('.jsc-loader-overlay');
    $loader.show();
      
    cartJSUpdateQuery(key, 0, {}, false);
    
    if (location.href.includes('/cart')) {
    }else{
    $(document).on('cart.requestComplete', function (event, cart) {
        location.reload();
        $loader.hide();
    });
    }
  }
  
  onloadRemoveSampleProduct = () => {
    var $obj = {};
    var $sample_total = parseInt($('.jsc-sample-total').val());
    var $isOnlySample = true;
    var $onlySample = {};
    var $loader = $('.jsc-loader-overlay');
    
  
    $.when($.getJSON('/cart.js', function(cart) {
      // check cart total
      $cartTotal = cart.total_price;
      if ($cartTotal < $sample_total) {
        for (let i = 0; i < cart.items.length; i++) {
          var $item = cart.items[i];
          if ($item.properties['_Item'] == 'Sample item') {
            $obj[$item.key] = 0;
          }
        }
        if ($.isEmptyObject($obj)) {
          if ($('.jsc-sample-collection-container').length && location.pathname == '/cart') {
            $('.jsc-sample-collection-container').remove();
          }
        }
      } else {
        if (!$('.jsc-sample-collection-container').length && location.pathname == '/cart' && $('.jsc-is-sample').length > 0) {
          location.reload();
        }
      }
  
      for (let i = 0; i < cart.items.length; i++) {
        var $item = cart.items[i];
        if ($item.properties['_Item'] == 'Sample item') {
          $onlySample[$item.key] = 0;
        } else {
          if ($isOnlySample) {
            $isOnlySample = false;  
          }
        }
      }
    })).then(function () {
        if (!$.isEmptyObject($obj)) {
            $loader.show();
            CartJS.updateItemQuantitiesById($obj);
            if (location.href.includes('/cart')) {
            }else{
            $(document).on('cart.requestComplete', function (event, cart) {
                // $loader.hide();
                location.reload();
            });
            }
        }
        if ($isOnlySample && !$.isEmptyObject($onlySample)) {
            $loader.show();
            CartJS.updateItemQuantitiesById($onlySample);
            if (location.href.includes('/cart')) {
            }else{
            $(document).on('cart.requestComplete', function (event, cart) {
                // $loader.hide();
                location.reload();
            });
            }
        }
    });
  }
  // Sample collection end
  //Start Master Promo Function
masterPromo = (isDrawer) =>{
  // Prevent multiple simultaneous runs
  if (isMasterPromoRunning) {
    console.log('MasterPromo: Already running, skipping...');
    return;
  }
  isMasterPromoRunning = true;
  
  if (location.href.includes('/cart')) {
    gwpTierFunction(isDrawer);
    cartGift();
    gwpFunction(isDrawer);
    pwpSetValidationCart();
    updateTolimitbundle();
    tierFunction(isDrawer);
    cartGiftProperties();
  }else{
    setTimeout(function(){
      gwpTierFunction(isDrawer);
      cartGift();
      gwpFunction(isDrawer);
      pwpSetValidationCart();
      updateTolimitbundle();
      tierFunction(isDrawer);
      cartGiftProperties();
    },1000);
  }
  
  // Reset flag after operations complete
  setTimeout(function() {
    isMasterPromoRunning = false;
  }, 3000);
}

//Start - Gift properties apps
cartGiftProperties = () =>{
  $('.jsc-update-gwp-apps').each(function(){
    var $key = parseInt($(this).val());
    var $qty = parseInt($(this).attr('data-qty'));
    var $gwpcart_product = {};
    $gwpcart_product['_Cart_GWP'] = 'Free Gift';
    cartJSUpdateQuery($key, $qty, $gwpcart_product);
  });
}
//End - Gift properties apps

//Start GWP Tier promo
gwpTierFunction = (isOpenDrawer) =>{
  // $.when($.getJSON('/cart.js', function(cart) {
  
  // })).then(function(cart){
      var $ele = $('._cartGwp');
      var $loader = $('.jsc-loader-overlay');

      $ele.each(function() {
        $loader.show();
        var $gwpcart_product = {};
        var $vid = parseInt($(this).attr('data-vid'));
        var $tierNo = $(this).attr('data-tier');
        var $tierCol = $(this).attr('data-col');
        $gwpcart_product['GWP Tier '+$tierNo] = true;
        $gwpcart_product['_Cart_GWP'] = 'Free Gift';
        if ( $tierCol ) {
          $gwpcart_product['_GWP_col'] = $tierCol;
        }

        if ($(this).length > 0) {
          cartJSAddQuery($vid, 1, $gwpcart_product, isOpenDrawer);
        }
      });

  // });

}
//End GWP promo
//Start GWP promo
gwpFunction = (isOpenDrawer) =>{
  $.when($.getJSON('/cart.js', function(cart) {

  })).then(function(cart){
    var $loader = $('.jsc-loader-overlay');
    var $gwpcart_product = {};
    var $addEle = $('.jsc-add-gwp');
    var $updateEle = $('.jsc-update-gwp');
    var $deleteEle = $('.jsc-remove-gwp');

    $gwpcart_product['_Promo'] = 'Free Gift';

    $addEle.each(function() {
      $loader.show();
      var $vid = parseInt($(this).val());
      var $qty = parseInt($(this).attr('data-qty'));

      $gwpcart_product['_Promo_no'] = $(this).attr('data-promo');

      console.log('test');

      cartJSAddQuery($vid, $qty, $gwpcart_product, isOpenDrawer);
    });

    $updateEle.each(function() {
      $loader.show();
      var $vid = $(this).val();
      var $qty = parseInt($(this).attr('data-qty'));

      $gwpcart_product['_Promo_no'] = $(this).attr('data-promo');

      cartJSUpdateQuery($vid, $qty, $gwpcart_product, isOpenDrawer);
    });

    $deleteEle.each(function() {
      $loader.show();
      var $vid = $(this).val();
      var $qty = 0;

      cartJSUpdateQuery($vid, $qty, {}, isOpenDrawer);
    });

    if (location.href.includes('/cart')) {
    }else{
      // Use namespaced event to prevent duplicate handlers
      $(document).off('cart.requestComplete.gwpFunction').on('cart.requestComplete.gwpFunction', function (event, cart) {
        $loader.hide();
        location.reload();
      });
    }

  });
}
//End GWP promo
//Start GWP based on cart, product or collection promo
cartGift = () =>{
  addCartGift();
  removeCartGift();
}

addCartGift = () =>{
  // Prevent double execution
  if (isGiftProcessing) {
    console.log('GWP: Already processing, skipping...');
    return;
  }
  
  var $loader = $('.jsc-loader-overlay');
  var $elem = $('.jsc-cart-gift');
  
  if ($elem.length === 0) {
    return;
  }
  
  isGiftProcessing = true;
  
  $elem.each(function(){
    $loader.show();
    var $vid = parseInt($(this).val());
    var $obj = {};
    var $promoNo = $(this).attr('data-promo');
    var $giftqty = parseInt($(this).attr('data-gift-qty'));

    $obj['_Cart_Gift'] = $promoNo;
    $obj['_Cart_GWP'] = 'Free Gift';
    if ($elem.length > 0) {
      cartJSAddQuery($vid,$giftqty,$obj,true);
    }
  });
  
  // Reset flag after a delay to allow cart operations to complete
  setTimeout(function() {
    isGiftProcessing = false;
  }, 2000);
  
  if (location.href.includes('/cart')) {
  }else{
    // Use namespaced event to prevent duplicate handlers
    $(document).off('cart.requestComplete.giftUpdate').on('cart.requestComplete.giftUpdate', function (event, cart) {
      $('.jsc-cart-gift-upt').each(function () {
        $loader.show();
        var $vid = $(this).val();
        var $qty = parseInt($(this).attr('data-qty'));
    
        var $obj = {};
        var $promoNo = $(this).attr('data-promo');
        $obj['_Cart_Gift'] = $promoNo;
        $obj['_Cart_GWP'] = 'Free Gift';
    
        cartJSUpdateQuery($vid, $qty, $obj, false);
      });
      $loader.hide();
      location.reload();
    });
  }
}

removeCartGift = () =>{
  var $loader = $('.jsc-loader-overlay');
  var $elem = $('.jsc-cart-gift-remove');
  $elem.each(function(){
    $loader.show();
    var $key = parseInt($(this).val());

    if ($elem.length > 0) {
      cartJSUpdateQuery($key, 0, {}, true);
    }
  });
  if (location.href.includes('/cart')) {
  }else{
    // Use namespaced event to prevent duplicate handlers
    $(document).off('cart.requestComplete.giftRemove').on('cart.requestComplete.giftRemove', function (event, cart) {
      $loader.hide();
      location.reload();
    });
  }
}
//End GWP based on cart, product or collection promo
//Start tier discount promo
tierFunction = (isOpenDrawer) =>{
  var $updateEle = $('.jsc-tier-product');
  var $removeEle = $('.jsc-tier-product-remove');

  $updateEle.each(function(){
    var $obj = {};
    var $this = $(this);
    var $key = $this.attr('data-key');
    var $discountVal = $this.val();
    var $discountType = $this.attr('data-discount-type');
    var $tierNo = $this.attr('data-promo-no');
    var $qty = parseInt($this.attr('data-qty'));

    $obj['_Quantity-Promo'] = $discountType;
    $obj['_Off-Value'] = $discountVal;
    $obj['_Promo-no'] = $tierNo;
    $obj['_Tier'] = true;

    cartJSUpdateQuery($key, $qty, $obj, isOpenDrawer);
  });

  $removeEle.each(function(){
    var $this = $(this);
    var $key = $this.val();
    var $promoNo = $this.attr('data-promo-no');
    $.when($.getJSON('/cart.js')).then(function(cart){
      var $items = cart.items;
      for (var i = 0; i < $items.length; i++) {
        var $thisKey = $items[i].key;
        var $thisQty = $items[i].quantity;
        var $thisProps = $items[i].properties;
        var $vID = parseInt($items[i].variant_id);

        if ($thisKey == $key && $thisProps['_Promo-no'] == $promoNo) {
          delete $thisProps['_Quantity-Promo'];
          delete $thisProps['_Off-Value'];
          delete $thisProps['_Promo-no'];
          delete $thisProps['_Tier'];

          var $isEmptyProperty = $.isEmptyObject($thisProps);
          if ($isEmptyProperty) {
            // if properties is empty then, remove the product and add back
            replaceProduct($thisKey, $vID, $thisQty, isOpenDrawer);
          } else {
            // if properties not empty then, just update the properties
            cartJSUpdateQuery($thisKey, $thisQty, $thisProps, isOpenDrawer);
          }
        }
      }
    });
  });
}

replaceProduct = ($key, $vid, $qty, isOpenDrawer) =>{
  CartJS.removeItemById($key,
  {
      "success": function(data, textStatus, jqXHR) {
      cartJSAddQuery($vid, $qty, {}, isOpenDrawer);
      },
      "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", errorThrown);
      }
  });
}
//End tier discount promo

//Start variant selected in pdp for bundle and pwp
variantOption = (evt, index, setValue) =>{
  var $this = $(evt);
  var $thisImgUrl = $this.find(':selected').attr('data-img');
  var $thisVid = $this.val();
  var $thisPrice = $this.find(':selected').attr('data-price');
  var $thisTitle = $this.find(':selected').text();
  var $thisComparePrice = $this.find(':selected').attr('data-compare-price');
  var $isDiscounted = $this.find(':selected').attr('data-settings-discount') == 'true';
  var $currencyFormat = $('html').attr('data-currency');
  var $variantTitleEle = $this.parents('.jsc-promo-grid').find('span.jsc-variant-title');

  var $hiddenEle = $this.parents('.jsc-container').find('.jsc-hidden');
  var $discountType = $hiddenEle.val();
  var $minusPrice = $discountType == 'percentage-off' ? parseFloat($hiddenEle.attr('data-'+$discountType+'-'+index)) : parseInt($hiddenEle.attr('data-'+$discountType+'-'+index));

  // update image
  $this.parents('.jsc-promo-grid').find('img').attr('src', $thisImgUrl);

  // update price
  if ($isDiscounted) { // if discount value is not empty in theme settings, then calculate the price
    var $discountedValue = 0;
    if ($discountType == 'percentage-off') {
      $discountedValue = $thisPrice * $minusPrice;
    } else {
      $discountedValue = $thisPrice - $minusPrice;
    }

    var price = $thisComparePrice;
    var discountprice = $thisPrice;

    console.log($this.siblings('.jsc-price').find('strike'),$this.siblings('.jsc-price').find('span'));

    $this.siblings('.jsc-price').find('strike').text(price);
    $this.siblings('.jsc-price').find('span').text(discountprice);
  } else { // if discount value is empty in theme settings, then show normal price
    if ($thisComparePrice) {
      var comparePrice = $thisComparePrice;
      $this.siblings('.jsc-price').find('strike').text(comparePrice);
      $this.siblings('.jsc-price').find('strike').show();
    } else {
      $this.siblings('.jsc-price').find('strike').hide();
    }
    var price = $thisPrice;
    $this.siblings('.jsc-price').find('span').text(price);
  }

  // update variant ID
  $this.parents('.jsc-promo-grid').attr('data-vid', $thisVid);

  // This function is to hide atc btn and show limit message if pwp reached the set limit
  if (setValue) {
    pwpSetValidationPdp(setValue, $this);
  }

  if ($variantTitleEle.length > 0) {
    $variantTitleEle.html($thisTitle);
  }
}
//End variant selected in pdp for bundle and pwp

//Start PWP promo
pwpAddToCart = (evt,discount2, discountType, index) =>{
  var $this = $(evt);
  var properties1 = {};
  var properties2 = {};
  var vid1 = parseInt($this.parents('.jsc-promoSection').find('.jsc-pwp-col-1').attr('data-vid'));
  var vid2 = parseInt($this.parents('.jsc-promoSection').find('.jsc-pwp-col-2').attr('data-vid'));
  var $bindId = vid1+'-'+vid2;


  properties1['_PWP'] = 'Master';
  properties1['_BindID'] = $bindId;
  properties1['_Promo-No'] = index;


  properties2['_Quantity-Promo'] = discountType;
  properties2['_Off-Value'] = discount2;
  properties2['_PWP'] = 'Child';
  properties2['_BindID'] = $bindId;
  properties2['_Promo-No'] = index;

  cartJSAddQuery(vid1, 1, properties1, true);
  cartJSAddQuery(vid2, 1, properties2, true);

  var cartType = $('#cart-type').val();
  
  /*
  if (cartType == 'page') {
    $(document).on('cart.requestComplete', function(event, cart) {
      if (location.href.includes('/cart')) {
        console.log('no need redirect');
      }else{
        window.location.href = '/cart';
      }
    });
  }

  $(document).on('cart.requestComplete', function(event, cart) {
    setTimeout(function(){
      masterPromo(false);
    },500);
  });
  */
}

removePwp = (evt, bindid, pwp) =>{
  setTimeout(function(){
    $.when($.getJSON('/cart.js')).then(function(cart){
      var $items = cart.items;
      for (var i = 0; i < $items.length; i++) {
        var $thisKey = $items[i].key;
        var $thisQty = $items[i].quantity;
        var $thisProps = $items[i].properties;
        var $vID = parseInt($items[i].variant_id);

        if ($thisProps['_BindID'] == bindid) {

          if (pwp == 'Master') {
            // if customer remove master product we remove the child product
            cartJSUpdateQuery($thisKey, 0, {}, true);
          } else if (pwp == 'Child') {
            // if customer remove child product we keep the master product, but remove the pwp properties
            delete $thisProps['_Quantity-Promo'];
            delete $thisProps['_Off-Value'];
            delete $thisProps['_BindID'];
            delete $thisProps['_PWP'];
            delete $thisProps['_Promo-No'];

            var $isEmptyProperty = $.isEmptyObject($thisProps);
            if ($isEmptyProperty) {
              // if properties is empty then, remove the product and add back
              replaceProduct($thisKey, $vID, $thisQty, true);
            } else {
              // if properties not empty then, just update the properties
              cartJSUpdateQuery($thisKey, $thisQty, $thisProps, true);
            }
          }
        }
      }
    });
  },900);
  $(document).on('cart.requestComplete', function(event, cart) {
    pwpSetValidationCart();
  });
}

updatePwp = (evt,bindid) =>{
  setTimeout(function(){
    $.when($.getJSON('/cart.js')).then(function(cart){
      var $items = cart.items;
      for (var i = 0; i < $items.length; i++) {
        var $thisKey = $items[i].key;
        var $thisQty = $items[i].quantity;
        var $thisProps = $items[i].properties;
        $thisQty -= 1;
        if ($thisProps['_BindID'] == bindid && $thisProps['_PWP'] == 'Child') {
          cartJSUpdateQuery($thisKey, $thisQty, $thisProps, true);
          console.log('slow333', $thisQty);
        }
      }
    });
  },900);
}

pwpSetValidationPdp = (setValue, $this) =>{
  var $v1 = $this.parents('.jsc-container').find('.jsc-pwp-col-1').attr('data-vid');
  var $v2 = $this.parents('.jsc-container').find('.jsc-pwp-col-2').attr('data-vid');
  var $bId = $v1+'-'+$v2;
  var $isInCart = false;
  $.when($.getJSON('/cart.js')).then(function(cart){
    var $items = cart.items;
    for (var i = 0; i < $items.length; i++) {
      var $thisQty = $items[i].quantity;
      var $thisProps = $items[i].properties;

      if ($thisProps['_BindID'] == $bId && $thisProps['_PWP'] == 'Child') {
        if ($thisQty >= setValue) { // if pwp variant have reached set limit
          $this.parents('.jsc-container').find('.jsc-set-limit-msg').show();
          $this.parents('.jsc-container').find('.jsc-atc-btn').hide();
        } else { // if pwp variant not yet reached set limit
          $this.parents('.jsc-container').find('.jsc-set-limit-msg').hide();
          $this.parents('.jsc-container').find('.jsc-atc-btn').show();
        }
        $isInCart = true;
      }
    }

    // if variant is not in cart
    if (!$isInCart) {
      $this.parents('.jsc-container').find('.jsc-set-limit-msg').hide();
      $this.parents('.jsc-container').find('.jsc-atc-btn').show();
    }
  });
}

pwpSetValidationCart = () =>{
  var $pwpContainer = $('.jsc-pwp-container');

  $pwpContainer.each(function(){
    var $this = $(this);
    var $v1 = $this.parents('.jsc-promoSection').find('.jsc-pwp-col-1').attr('data-vid');
    var $v2 = $this.parents('.jsc-promoSection').find('.jsc-pwp-col-2').attr('data-vid');
    var $bId = $v1+'-'+$v2;
    var $isInCart = false;
    var $setValue = parseInt($this.attr('data-set'));

    if ($setValue) {
      $.when($.getJSON('/cart.js')).then(function(cart){
        var $items = cart.items;
        for (var i = 0; i < $items.length; i++) {
          var $thisQty = $items[i].quantity;
          var $thisProps = $items[i].properties;

          if ($thisProps['_BindID'] == $bId && $thisProps['_PWP'] == 'Child') {
            if ($thisQty >= $setValue) { // if pwp variant have reached set limit
              $this.parents('.jsc-promoSection').find('.jsc-set-limit-msg').show();
              $this.parents('.jsc-promoSection').find('.jsc-atc-btn').hide();
            } else { // if pwp variant not yet reached set limit
              $this.parents('.jsc-promoSection').find('.jsc-set-limit-msg').hide();
              $this.parents('.jsc-promoSection').find('.jsc-atc-btn').show();
            }
            $isInCart = true;
          }
        }
        // if variant is not in cart
        if (!$isInCart) {
          $this.parents('.jsc-promoSection').find('.jsc-set-limit-msg').hide();
          $this.parents('.jsc-promoSection').find('.jsc-atc-btn').show();
        }
      });
    }
  });
}
//End PWP promo
//Start bundle promo
bundleAddToCart = (evt,discount1,discount2, discountType, i) =>{
  var $this = $(evt);
  var properties1 = {};
  var properties2 = {};
  var vid1 = parseInt($this.parents('.jsc-promoSection').find('.jsc-bundle-col-1').attr('data-vid'));
  var vid2 = parseInt($this.parents('.jsc-promoSection').find('.jsc-bundle-col-2').attr('data-vid'));
  var $bindId = vid1+'-'+vid2;


  properties1['_Quantity-Promo'] = discountType;
  properties1['_Off-Value'] = discount1;
  properties1['_Bundle'] = true;
  properties1['_BindID'] = $bindId;
  properties1['_Promo-no'] = i;

  properties2['_Quantity-Promo'] = discountType;
  properties2['_Off-Value'] = discount2;
  properties2['_Bundle'] = true;
  properties2['_BindID'] = $bindId;
  properties2['_Promo-no'] = i;

  cartJSAddQuery(vid1, 1, properties1, true);
  cartJSAddQuery(vid2, 1, properties2, true);
  
  /*
  var cartType = $('#cart-type').val();
  if (cartType == 'page') {
    $(document).on('cart.requestComplete', function(event, cart) {
      if (location.href.includes('/cart')) {
        console.log('no need redirect');
      }else{
        window.location.href = '/cart';
      }
    });
  }

  $(document).on('cart.requestComplete', function(event, cart) {
    setTimeout(function(){
      masterPromo(false);
    },1000);
  });
  */
}

updateTolimitbundle = () =>{
  var $uptEle = $('.jsc-update-bundle-fix');
  $uptEle.each(function(){
    var $this = $(this);
    var $key = $this.val();
    var discountType = $this.attr('data-discType');
    var discount = $this.attr('data-offvalue');
    var $bindId = $this.attr('data-bindId');
    var i = $this.attr('data-promo');
    var $thisQty = $this.attr('data-qty');
    var properties = {};
    properties['_Quantity-Promo'] = discountType;
    properties['_Off-Value'] = discount;
    properties['_Bundle'] = true;
    properties['_BindID'] = $bindId;
    properties['_Promo-no'] = i;
    properties['_Limit-Discount'] = true;
    cartJSUpdateQuery($key, $thisQty, properties, true);
  });
}

removeBundle = (evt, bindid, key) =>{
  cartJSUpdateQuery(key, 0);
  $(document).on('cart.requestComplete', function(event, cart) {
    bundleCartAjax(bindid);
  });
}

removeBundleOnThemeSettings = () =>{
  var $removeEle = $('.jsc-remove-bundle');

  $removeEle.each(function(){
    var $this = $(this);
    var $bindId = $this.val();
    var $container = $('.'+$this.attr('data-container'));

    if ($container.length > 0) {
      $container.hide();
    }

    setTimeout(function(){
      bundleCartAjax($bindId);
    },900);
  })

}

bundleCartAjax = (bindid) =>{
  $.when($.getJSON('/cart.js')).then(function(cart){
    var $items = cart.items;
    for (var i = 0; i < $items.length; i++) {
      var $thisKey = $items[i].key;
      var $thisQty = $items[i].quantity;
      var $thisProps = $items[i].properties;
      var $vID = parseInt($items[i].variant_id);

      if ($thisProps['_BindID'] == bindid) {
        delete $thisProps['_Quantity-Promo'];
        delete $thisProps['_Off-Value'];
        delete $thisProps['_Bundle'];
        delete $thisProps['_BindID'];
        delete $thisProps['_Promo-no'];

        var $isEmptyProperty = $.isEmptyObject($thisProps);
        if ($isEmptyProperty) {
          // if properties is empty then, remove the product and add back
          replaceProduct($thisKey, $vID, $thisQty, true);
        } else {
          // if properties not empty then, just update the properties
          cartJSUpdateQuery($thisKey, $thisQty, $thisProps, true);
        }
      }
    }
  });
}
//End bundle promo

formatString = (n) =>{
  var chars = n.substring(0,3);
  var xChar = n.substr(3).replace(/\D/g,'x');

  var newLastName = chars + xChar;

  return newLastName;
}
oneCardRemove = (e,cusId) => {
  var $this = $(e);
  var $loader = $('.jsc-loader-overlay');
  $loader.show();
  
  // Run Mechanic webhook
  let $data = {
    customerId: cusId
  };
  $.ajax({
    url: 'https://webhooks.mechanic.dev/9794285e-6706-4464-8a28-312a20ee09ad',
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    data: JSON.stringify($data)
  }).done(function () {
    $('#jsc-id-num').val('');
    $loader.hide();
    $this.hide();
  });
}
oneCardVerfication = (e, dT, cusId) =>{
  var $this = $(e);
  var $loader = $('.jsc-loader-overlay');
  var $oneCardNoEle = $('#jsc-id-num');
  var $oneCardNo = $oneCardNoEle.val();

  $loader.show();

  if ($oneCardNo != '') {
    $('#jsc-one-card-error').hide();
    let _data = {
      sourceTransID: `CMG_${cusId}_${dT}`,
      requestTime: dT,
      cardNo: $oneCardNo,
      customerId: cusId
    };
    $.ajax({
      url: 'https://webhooks.mechanic.dev/773f9aae-1364-4489-a8f5-1bef376c414a', // user/migrate/onecard
      method: 'POST',
      headers: {
        'content-type': 'application/json'
      },
      data: JSON.stringify(_data)
    }).done(function () {
      setTimeout(function(){
        $loader.hide();
        location.reload();
      },6000);
    });
  } else {
    $('#jsc-one-card-error').show();
    $('#jsc-one-card-ajax-error').hide();
    $('#jsc-one-card-success').hide();
    $loader.hide();
  }
}

removeOneCardError = () =>{
  var isTriggerRemoveTag = $('#trigger-remove-error').length;

  if (isTriggerRemoveTag) {
    var tag_val = $('#trigger-remove-error').val();
    var customer_id = $('#trigger-remove-error').attr('data-id');
    let _data = {
      tag: tag_val,
      customer_id: customer_id
    };
    $.ajax({
      url: 'https://webhooks.mechanic.dev/509981c4-ba91-414a-800e-7f23d2138cbc', // user/migrate/onecard_remove_error
      method: 'POST',
      headers: {
        'content-type': 'application/json'
      },
      data: JSON.stringify(_data)
    }).done(function () {
      
    });
  }
}

isInvoice = (e) =>{
  var $this = $(e);
  var $val = $this.val();
  var $html = `<p class="cart-attribute__field jsc-personal-company m-t-15">
    <label class="fontWeight-9 line-height-2 ">คุณต้องการขอใบกำกับภาษีในนามบุคคลหรือนิติบุคคล</label><br>
    <input type="radio" onchange="isPersonalOrCompany(this)" id="jsc-personal-radio" class="vertical-middle jsc-radio cursor" name="attributes[Are you a Personal or Company (Individual Company)]" value="Personal"> <label class="vertical-middle fontWeight-9 cursor p-r-25 inline m-b-0" for="jsc-personal-radio">ส่วนบุคคล</label>
    <input type="radio" onchange="isPersonalOrCompany(this)" id="jsc-company-radio" class="vertical-middle jsc-radio cursor" name="attributes[Are you a Personal or Company (Individual Company)]" value="Company"> <label class="vertical-middle fontWeight-9 cursor inline m-b-0" for="jsc-company-radio">ในนามบริษัท</label><br>
  </p>`;

  if ($val == 'Yes') {
    $('.jsc-tax-invoice-inputs').append($html);
  } else {
    if ($('.jsc-personal-company').length) {
      $('.jsc-personal-company').remove();
    }
    if ($('.jsc-personal').length) {
      $('.jsc-personal').remove();
    }
    if ($('.jsc-company').length) {
      $('.jsc-company').remove();
    }
  }
}

isPersonalOrCompany = (e) =>{
  var $this = $(e);
  var $val = $this.val();

  if ($val == 'Personal') {
    var $html = `<div class="jsc-personal jsc-inputs-details m-t-15">
      <p class="fontWeight-9 line-height-2">ส่วนบุคคล</p>
      <p class="cart-attribute__field form-control relative m-b-20">
        <input required class="required input full-width" id="tax-id" maxlength="13" type="text" name="attributes[vat_id]" value="" placeholder="เลขประจำตัวผู้เสียภาษี">
        <label class="floating-label text-xs opacity-1" for="tax-id">เลขประจำตัวผู้เสียภาษี<span style="color: red;"> *</span></label>
      </p>
      <p id="jsc-required-text" class="m-t-15" style="margin-top: -5px; display: none; color: red;font-size: 10px;">* This is a required field</p>
      <span class="full-height text-center p-t-15 p-b-15 button" onclick="saveCartAttr(this)"><span>บันทึกเพื่ออัปเดต</span></span>
    </div>`;
    $('.jsc-tax-invoice-inputs').append($html);
    if ($('.jsc-company').length) {
      $('.jsc-company').remove();
    }
  } else {
    var $html = `<div class="jsc-company jsc-inputs-details m-t-15">
      <p class="fontWeight-9 line-height-2">ในนามบริษัท</p>
      <p class="cart-attribute__field form-control relative m-b-30">
        <input required class="required full-width input" id="tax-id" maxlength="13" type="text" name="attributes[vat_id]" value="" placeholder="เลขประจำตัวผู้เสียภาษี">
        <label class="floating-label text-xs opacity-1" for="tax-id">เลขประจำตัวผู้เสียภาษี<span style="color: red;"> *</span></label>
      </p>
      <p class="cart-attribute__field form-control relative m-b-30">
        <input required class="required full-width input" id="company-name" type="text" name="attributes[company]" value="" placeholder="ชื่อบริษัท">
        <label class="floating-label text-xs opacity-1" for="company-name">ชื่อบริษัท<span style="color: red;"> *</span></label>
      </p>
      <p class="cart-attribute__field form-control relative m-b-30">
        <select onchange="onChangeBType(this)" required class="required full-width input" id="branch-type" name="attributes[Branch Type]">
          <option value="Headquarter">สำนักงานใหญ่</option>
          <option value="Branch">สาขา</option>
        </select>
        <label class="floating-label text-xs opacity-1" for="branch-type">ประเภทของสำนักงาน<span style="color: red;"> *</span></label>
      </p>
      <p class="cart-attribute__field form-control relative m-b-20">
        <input required class="required full-width input m-b-0" id="branch-id" type="text" maxlength="5" name="attributes[branch_id]" value="00000" placeholder="รหัสสาขา">
        <label class="floating-label text-xs opacity-1" for="branch-id">รหัสสาขา<span style="color: red;"> *</span></label>
        <span id="jsc-b-id-overlay"></span>
      </p>
      <p id="jsc-required-text" class="m-t-15" style="margin-top: -5px; display: none; color: red;font-size: 10px;">* This is a required field</p>
      <span class="full-height text-center p-t-15 p-b-15 button" onclick="saveCartAttr(this)"><span>บันทึกเพื่ออัปเดต</span></span>
    </div>`;
    $('.jsc-tax-invoice-inputs').append($html);
    if ($('.jsc-personal').length) {
      $('.jsc-personal').remove();
    }
  }
}

saveCartAttr = (e) =>{
  var $this = $(e);
  var $inputs = $this.parents('.jsc-inputs-details').find('input');
  var isFilled = true;

  $inputs.each(function(){
    var $_this = $(this);
    var $_val = $_this.val();
    console.log('dddd',$_val);

    if (!$_val) {
      isFilled = false;
    }
  });

  if (isFilled) {
    $('#jsc-required-text').hide();
    $this.html('<span>บันทึกเสร็จแล้ว!</span>');
    cartJSSaveAttr();
  } else {
    $('#jsc-required-text').show();
    $this.html('<span>บันทึกเพื่ออัปเดต</span>');
  }
}

cartJSSaveAttr = () =>{
  var input_elements = $('.jsc-tax-invoice').find('input');
  var dataObject = {};
  var isPersonal = false;

  input_elements.each(function() {
    var inputType = $(this).attr('type');
    var inputName = $(this).attr('name');
    var inputValue;

    if (inputType === 'text') {
      // For text inputs, capture the value directly
      inputValue = $(this).val();
    } else if (inputType === 'radio' && $(this).is(':checked')) {
      // For radio inputs, capture the value only if it's checked
      inputValue = $(this).val();
      if ($(this).val() == 'Personal') {
        isPersonal = true;
      }
    }

    // Extract the value inside the square brackets
    var matches = inputName.match(/\[([^\]]+)\]/);
    var key = matches ? matches[1] : null;

    if (isPersonal) {
      dataObject['company'] = 'N/A';
      dataObject['branch_id'] = 'N/A';
    }

    // Add the data to the object if name and value are defined
    if (inputName && inputValue !== undefined) {
      dataObject[key] = inputValue;
    }
  });

  // set attribute
  CartJS.setAttributes(dataObject);
}

getTaxAttr = () =>{
  
  $.getJSON('/cart.js', function(cart) {
    var cart_attr_obj = cart.attributes;
    
    if (cart_attr_obj.isFullTax) {
      $(`#jsc-${cart_attr_obj.isFullTax.toLowerCase()}-radio`).click();
    }
    if (cart_attr_obj['Are you a Personal or Company (Individual Company)']) {
      $(`#jsc-${cart_attr_obj['Are you a Personal or Company (Individual Company)'].toLowerCase()}-radio`).click();
    }
    if ($('#tax-id').length != 0) {
      $('#tax-id').val(cart_attr_obj.vat_id);
    }
    if ($('#company-name').length != 0) {
      $('#company-name').val(cart_attr_obj.company);
    }
    if ($('#branch-id').length != 0) {
      $('#branch-id').val(cart_attr_obj.branch_id);
    }
  });
  
}

onChangeBType = (e) => {
  var $this = $(e);
  var $val = $this.val();

  if ($val == 'Headquarter') {
    $('#jsc-b-id-overlay').show();
    $('#branch-id').val('00000');
  } else {
    $('#jsc-b-id-overlay').hide();
    $('#branch-id').val('');
  }
}

//START close button announcement bar
function myFunction() {
  var x = document.getElementById("jsc-announcement-bar-close");
  if (x.style.display === "none") {
    x.style.display = "block";
  } else {
    x.style.display = "none";
  }
}

//END close button announcement bar

jscCarouselProgressBar = (e, target) => {
  var $this = $(e);
  var $width = 0;
  var $progressBar = $this.parents('.container').find('.jsc-progress-bar');

  $this.children().each(function () {
    var _this = $(this);
    $width += _this.width();
  });

  var $temp = 0;
  

  if ($(window).width() > 480) {
    $temp = target / ($width - ($this.children().last().width() * 3));
  } else {
    $temp = target / ($width - ($this.children().last().width() * 1));
  }

  var $percentage = Math.max(0, Math.min(1, $temp)) * 100;


  $progressBar.width(`${$percentage}%`);

  if ($width < $this.width()) {
    // hide progress bar for list that are not scrolable
    $this.parents('.container').find('carousel-progress-container').hide();
  }
  
}

//start: Preselect the third level navigation
jscPreselectNav = (e, title) => {
  console.log("title:", title);

  var found = false;  // Flag to track if a matching element is found

  $('.jsc-details').each(function () {
    var parentTitle = $(this).data('parent-title');

    if (parentTitle === title) {

      if (!found) {
        $(this).attr({
          'open': true,
          'aria-expanded': true
        });

        found = true;
      }
    }
  });
};
//end: Preselect the the third level navigation
// start: init mySwiper
initMySwiper = () => {
  console.log("initMySwiper");
  var swiper = new Swiper(".mySwiper", {
      pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      slidesPerView: 'auto',
      initialSlide : 0
  });
}
// end: init mySwiper
// start: update complete the set selection
updateComplementaryProduct = (e) => {
  var _this = $(e);
  const radioName = _this.attr('name');
  var item_price = _this.siblings('.jsc-add-ons').attr('data-price');

  $(`input[name='${radioName}']`).prop('checked', false);
  $(`input[name='${radioName}']`).siblings('label').removeClass('active');
  $(`input[name='${radioName}']`).parent().parent('.swiper-wrapper').removeClass('required');

  var required_message = _this.closest('.accordion__content').siblings('summary').find('.alert-message');
  required_message.addClass('d-none');

  _this.prop('checked', true);
  _this.siblings('label').addClass('active');

  const selectedValue = _this.val();

  $(`#${radioName}-selected`).text(selectedValue);
  $(`#${radioName}-selected`).css('color', '#333333');
  $(`#${radioName}-price`).text(item_price);
  $(`#${radioName}-price`).removeClass('d-none');

  calculateTotalAmount(item_price, radioName);
}
// end: update complete the set selection

// start: complete the set
calculateTotalAmount = (price, name) => {
  var total_container = $('.complementary-collections__total-amount');
  var line_item_container = $(total_container).find('.total-amount__line-item-price');
  var total_amount_price = $(total_container).find('.total-amount__price');
  var item_price = $(total_container).find(`.${name}-price`);
  var total = 0;

  if ($(item_price).length > 0) {
    $(item_price).text(price);
  } else {
    var _html = `<p class="${name}-price">${price}</p>`;
    $(line_item_container).append(_html);
  }

  $(line_item_container).find('p').each(function() {
    var priceText = $(this).text().trim().replace(/[^\d.]/g, '');
    priceText = parseFloat(priceText);
    total += priceText;
  });

  var formatedShopifyMoney = window.themeVariables.settings.moneyWithCurrencyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, total.toFixed(2));
  $(total_amount_price).text(formatedShopifyMoney);
  $(total_amount_price).attr('data-price', total * 100);
  $(total_container).closest('.product-info__block-item[data-block-type="buy-buttons"]').siblings('.product-info__block-item[data-block-type="price"]').find('price-list sale-price').text(formatedShopifyMoney);
}

addCTS = (e, vid) =>{
  var loader = $('.jsc-loader-overlay');
  var _this = $(e);
  var _activeSelection = $('.jsc-add-ons.active');
  var required = $('.complementary-collections__container .required');
  var _html = '';
  var _temp = 1;
  var _bindId = vid;
  var itemsArray = [];
  var _currentDate = new Date();
  var _timestamp = _currentDate.getTime();
  var _total_amount = $('.complementary-collections__total-amount .total-amount__price').attr('data-price');

  if ($(required).length > 0) {
     $(required).each((index, element) => {
      var required_message = $(element).closest('.accordion__content').siblings('summary').find('.alert-message');
      required_message.removeClass('d-none');
      $('.js-form-error').text('Please select all required products before add to cart');
      $('.js-form-error').show();
     });
  } else {
     $('.js-form-error').attr('hidden');

     _activeSelection.each(function(){
        var _active = $(this);
        var _title = _active.attr('data-title');
        var _vid = _active.attr('data-vid');
        var _price = _active.attr('data-price');
        var _propertiesName = _active.closest('.accordion__content').siblings('summary').find('.complementary-collection__title').text();

        if (_title != '') {
           var _objs = {
              id: _vid,
              quantity: 1,
              properties: {
                 "_bindId": "blank",
                 "_Add_ons": true
              }
           }
           itemsArray.push(_objs);
        }
  
        _html += `<input type="text" name="properties[${_temp}_${_propertiesName}]" value="${_title} x 1 - ${_price}" style="display: none;">`;
        _bindId += `-${_vid}`;
  
        _temp++;
     });
  
     $.each(itemsArray, function(index, item) {
        item.properties['_bindId'] = _bindId + '__' + _timestamp;
    });
  
    CartJS.addItems(itemsArray);
  
    _html += `<input type="text" name="properties[_bindId]" value="${_bindId + '__' + _timestamp}" style="display: none;"><input type="text" name="properties[_main_product]" value="true" style="display: none;"><input type="text" name="properties[_total_amount]" value="${_total_amount}" style="display: none;">`;
  
     $(_html).insertBefore(_this);
  
     $(document).on('cart.requestComplete', function(event, cart) {
      // var main_button = _this.siblings('.jsc-add-to-cart').find('button[type="submit"]');
      // main_button.click();
      sessionStorage.setItem('addCTSComplete', 'true');
      loader.show();
     });
  }
}

addCTSComplete = () => {
  var loader = $('.jsc-loader-overlay');
  if (sessionStorage.getItem('addCTSComplete') === 'true') {
    sessionStorage.removeItem('addCTSComplete');
    setTimeout(() => {
      sessionStorage.setItem('cartDrawerOpen', 'true');
      location.reload();
      loader.hide();
    }, 1000);
  }
}
openCartDrawer = () => {
  if (sessionStorage.getItem('cartDrawerOpen') === 'true') {
    sessionStorage.removeItem('cartDrawerOpen');
    $('#cart-drawer').attr({
      'aria-modal': 'true',
      'open': ''
    }).css('display', 'block');
  }
}

removeCTS = (e) =>{
  var _this = $(e);
  var obj = {};

  // Get the bind ID
  var bindId = _this.attr('data-bindid');
  var selector = $(`.jsc-bindid-${bindId}`);

  selector.each(function(){
     obj[$(this).attr('data-key')] = 0;
  });

  CartJS.updateItemQuantitiesById(obj);

  $(document).on('cart.requestComplete', function(event, cart) {
     setTimeout(() => {
        location.reload();
     }, 3000);
  });
}
// end: complement the set